export default __webpack_public_path__ + "static/media/bg-coupon-disable-vip.783db6bd.png";